import { render, staticRenderFns } from "./Proceedings.vue?vue&type=template&id=97a8a406&scoped=true"
import script from "./Proceedings.vue?vue&type=script&lang=js"
export * from "./Proceedings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a8a406",
  null
  
)

export default component.exports